import { FooterProps } from '@design-system/footer';

import TMPLinkWrap from '~/components/TMPLinkWrap';
import { iconMapper } from '~/mappers/common';
import { linkMapper } from '~/mappers/link';
import { typographyMapper } from '~/mappers/typography';

import { countryPickerMapper } from '../countryPicker';
import { Footer } from './models';

export const footerMapper = ({
  navigation,
  socialLinks,
  legal,
  disclaimer,
  mode,
  uid,
  medicalAddon,
  countryPicker,
}: Footer): FooterProps => ({
  navigationData: navigation.map(linkMapper),
  iconsData: socialLinks[0]?.links.map(linkMapper),
  copyright: legal,
  iconsHeading:
    socialLinks[0]?.header && !socialLinks[0]?.hideHeader
      ? typographyMapper({
          ...socialLinks[0].header,
          className: socialLinks[0]?.hideHeader ? 'hidden' : undefined,
        })
      : undefined,
  mode,
  disclaimer,
  LinkNavElement: TMPLinkWrap,
  uid,
  medicalAddon: medicalAddon?.map((item) => ({
    ...item,
    icon: { props: iconMapper(item.icon[0]) },
  })),
  countryPicker: countryPickerMapper(countryPicker),
});
